import React from 'react';

const InformasiSection = () => {
  const informasi = [
    {
      id: 1,
      judul: 'BUMDES Desa Makmur Raih Penghargaan',
      excerpt: 'BUMDES Desa Makmur mendapatkan penghargaan sebagai BUMDES terbaik se-kabupaten tahun 2024...',
      tanggal: '15 Jan 2024',
      kategori: 'Prestasi',
      penulis: 'Admin BUMDES',
      dibaca: 124
    },
    {
      id: 2,
      judul: 'Pelatihan Pengolahan Hasil Pertanian',
      excerpt: 'Akan diadakan pelatihan pengolahan hasil pertanian untuk meningkatkan nilai jual produk...',
      tanggal: '10 Jan 2024',
      kategori: 'Kegiatan',
      penulis: 'Tim Pengembangan',
      dibaca: 89
    },
    {
      id: 3,
      judul: 'Laporan Keuangan Triwulan IV 2023',
      excerpt: 'Laporan keuangan BUMDES untuk triwulan IV tahun 2023 telah tersedia untuk diakses...',
      tanggal: '5 Jan 2024',
      kategori: 'Laporan',
      penulis: 'Bendahara',
      dibaca: 156
    }
  ];

  const getCategoryColor = (kategori) => {
    switch (kategori) {
      case 'Prestasi':
        return 'bg-green-100 text-green-800';
      case 'Kegiatan':
        return 'bg-blue-100 text-blue-800';
      case 'Laporan':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <section id="informasi" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Informasi Terbaru
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Update terbaru seputar kegiatan dan perkembangan BUMDES Desa Makmur
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {informasi.map((item) => (
            <article 
              key={item.id}
              className="bg-gray-50 rounded-2xl overflow-hidden hover:shadow-lg transition-shadow duration-300 group"
            >
              <div className="h-48 bg-gradient-to-br from-blue-200 to-green-200 relative overflow-hidden">
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300"></div>
                <div className="absolute top-4 left-4">
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${getCategoryColor(item.kategori)}`}>
                    {item.kategori}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 text-white">
                  <div className="text-3xl">
                    {item.kategori === 'Prestasi' ? '🏆' : 
                     item.kategori === 'Kegiatan' ? '📅' : '📊'}
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-3">
                  <span>{item.tanggal}</span>
                  <span className="mx-2">•</span>
                  <span>👁️ {item.dibaca} dibaca</span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary transition-colors">
                  {item.judul}
                </h3>
                
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {item.excerpt}
                </p>
                
                <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                  <div className="flex items-center text-sm text-gray-500">
                    <span className="w-6 h-6 bg-primary rounded-full flex items-center justify-center text-xs text-white mr-2">
                      {item.penulis.charAt(0)}
                    </span>
                    {item.penulis}
                  </div>
                  <button className="text-primary hover:text-blue-700 font-medium text-sm transition-colors">
                    Baca Selengkapnya →
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* More News CTA */}
        <div className="text-center mt-12">
          <a
            href="#login"
            className="inline-flex items-center bg-primary text-white px-6 py-3 rounded-lg font-bold hover:bg-blue-700 transition-colors duration-200"
          >
            <span>Lihat Semua Informasi</span>
            <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default InformasiSection;